const backControl = require("../../js/back-control");
const texteditorDefault = require("./texteditor-default");
const texteditorGenerator = require("./texteditor-generator");

/****************ELEMENTS*****************/
var texteditor;
var scrimtexteditor;
var HTMLwasSelected = false;

function HTMLselect() {
//   console.log('HTMLselect')

  texteditor = document.getElementById("texteditor");
  scrimtexteditor = document.getElementById("scrim_texteditor");
  HTMLwasSelected = true;
}

/****************ELEMENTS*****************/

export function start(detail) {
  // console.log('texteditor start>', detail)

  switch (detail.act) {
    case "show":
      show(detail);
      break;
    case "hide":
      hide();
      break;
  }
}

function show(detail) {
  //console.log('texteditor show>', detail)

  if (!HTMLwasSelected) {
    HTMLselect();
  }

  var texteditorBody = "";

  //create html elements or generate one default
  switch (detail.html) {
    case undefined:
      texteditorBody = texteditorDefault.start(detail);
      break;
    default:
      texteditorBody = detail.html;
  }

  //fill the menu
  texteditor.innerHTML = texteditorGenerator.start(texteditorBody);

  //show the element
  texteditor.classList.add("texteditor-show");

  //show the element
  scrimtexteditor.classList.add("scrim-show");

  //add to the url
  backControl.hashAdd({ toShow: "texteditor" });
}

function hide() {
  //console.log('texteditor hide>')

  if (!HTMLwasSelected) {
    HTMLselect();
  }

  texteditor.classList.add("texteditor-hide");
  scrimtexteditor.classList.add("scrim-hide");

  //remove to the url
  backControl.hashSub({ toHide: "texteditor" });

  remove(() => {
    texteditor.classList.remove("texteditor-hide");
    texteditor.classList.remove("texteditor-show");

    scrimtexteditor.classList.remove("scrim-show");
    scrimtexteditor.classList.remove("scrim-hide");

    texteditor.innerHTML = "";
  });
}

function remove(callback) {
  setTimeout(() => {
    callback();
  }, 300);
}
